<app-spinner></app-spinner>
<app-banner-popup></app-banner-popup>
<router-outlet />
